import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { TextSliderSharedComponent } from './text.slider.components';

import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { DatepickerSharedModule } from '../datepicker/datepicker.module';

@NgModule({
    declarations: [
        TextSliderSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule,
        DatepickerSharedModule,
        NgbDatepickerModule.forRoot()
    ],
    exports: [
        TextSliderSharedComponent
    ]
})

export class TextSliderSharedModule {}
